module.exports = __webpack_public_path__ + "static/media/weather-journal3.8321d837.png";